module.exports = __webpack_public_path__ + "static/media/edit.5241b700.svg";